import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xingternal/button';
import { IconNotificationCenter } from '@xingternal/icons';

import { useEditAlertMode } from '../../hooks';

import * as S from './search-alert-banner.styles';

type Props = {
  isLoggedIn: boolean;
  isAlertActive: boolean;
  isMaximumReached: boolean;
  areAlertsInitialized: boolean;
  onClickHandler: () => void;
};

export const SearchAlertBannerCta: React.VFC<Props> = ({
  isLoggedIn,
  isAlertActive,
  isMaximumReached,
  areAlertsInitialized,
  onClickHandler,
}) => {
  const { isEditingSearchAlert } = useEditAlertMode();

  if (isMaximumReached) {
    return null;
  }

  if (!isLoggedIn) {
    return (
      <S.Button variant="primary" size="medium" icon={IconNotificationCenter} onClick={onClickHandler}>
        <FormattedMessage id="MP_400_ACTIVATE_BUTTON" />
      </S.Button>
    );
  }

  if (isEditingSearchAlert && !isAlertActive) {
    return (
      <Button variant="secondary" size="small" onClick={onClickHandler}>
        <FormattedMessage id="JOBS_SEARCH_EDIT_ALERT_BANNER_SAVE_BUTTON" />
      </Button>
    );
  }

  return (
    <S.Toggle
      on={isAlertActive}
      disabled={!areAlertsInitialized}
      onChange={onClickHandler}
      aria-pressed={isAlertActive}
      role="button"
      aria-labelledby="search-alert-banner-toggle"
    />
  );
};
